import type {SectionHeroProps} from './components/SectionHero/SectionHero'
import SectionTemplate from './components/SectionTemplate/SectionTemplate'

const COPY = {
  intro: {
    title: 'Accelerate performance',
    description:
      'With Copilot embedded throughout the platform, you can simplify your toolchain, automate tasks, and improve the developer experience.',
  },
  hero: {
    aria: {
      // TODO: Update once known
      autoPlayButton: {
        play: 'Play',
        pause: 'Pause',
      },
    },
  },
  content: {
    title: 'Work 55% faster.',
    description: ' Increase performance with AI-powered coding assistance, including code completion, chat, and more.',
    footnote: {
      number: 1,
      text: 'Survey: The AI wave continues to grow on software development teams, 2024.',
    },
    link: {
      url: '/features/copilot',
      label: 'Explore GitHub Copilot',
    },
  },
  customers: [
    {
      logo: {
        url: '/images/modules/site/home24/automation/logo-duolingo.svg',
        // TODO: Update once known
        alt: '',
        height: 32,
      },
      description: 'Discover how Duolingo increased developer speed with Copilot',
      link: {
        url: '/customer-stories/duolingo',
        label: 'Read customer story',
      },
    },
    {
      logo: {
        url: '/images/modules/site/home24/automation/logo-gartner.svg',
        // TODO: Update once known
        alt: '',
        height: 24,
      },
      description: '2024 Gartner® Magic Quadrant™ for AI Code Assistants',
      link: {
        url: 'https://www.gartner.com/doc/reprints?id=1-2IKO4MPE&ct=240819&st=sb',
        label: 'Read the report',
      },
    },
  ],
  accordion: [
    {
      title: 'Automate any workflow',
      description: 'Optimize your process with simple and secured CI/CD.',
      link: {
        label: 'Discover GitHub Actions',
        url: '/features/actions',
      },
      visual: {
        url: '/images/modules/site/home24/automation/accordion-1.webp',
        // TODO: Update once known
        alt: '',
      },
    },
    {
      title: 'Get up and running in seconds',
      description: 'Start building instantly with a comprehensive dev environment in the cloud.',
      link: {
        label: 'Check out GitHub Codespaces',
        url: '/features/codespaces',
      },
      visual: {
        url: '/images/modules/site/home24/automation/accordion-2.webp',
        // TODO: Update once known
        alt: '',
      },
    },
    {
      title: 'Build on the go',
      description: 'Manage projects and chat with GitHub Copilot from anywhere.',
      link: {
        label: 'Download GitHub Mobile',
        url: '/mobile',
      },
      visual: {
        url: '/images/modules/site/home24/automation/accordion-3.webp',
        // TODO: Update once known
        alt: '',
      },
    },
    {
      title: 'Integrate the tools you love',
      description: 'Sync with 17,000+ integrations and a growing library of Copilot Extensions.',
      link: {
        label: 'Visit GitHub Marketplace',
        url: '/marketplace',
      },
      visual: {
        url: '/images/modules/site/home24/automation/accordion-4.webp',
        // TODO: Update once known
        alt: '',
      },
    },
  ],
}

// TODO: Update once known
const HERO_VISUALS: SectionHeroProps['visuals'] = [
  {
    url: '/images/modules/site/home24/automation/hero-1.webp',
    alt: '',
  },
  {
    url: '/images/modules/site/home24/automation/hero-2.webp',
    alt: '',
  },
  {
    url: '/images/modules/site/home24/automation/hero-3.webp',
    alt: '',
  },
]

export default function Automation() {
  return (
    <section id="automation" className="lp-Section">
      <SectionTemplate
        intro={{
          mascot: 'copilot',
          title: COPY.intro.title,
          description: COPY.intro.description,
        }}
        hero={{visuals: HERO_VISUALS, autoPlayButtonAriaLabel: COPY.hero.aria.autoPlayButton}}
        content={COPY.content}
        customers={COPY.customers}
        accordion={COPY.accordion}
      />
    </section>
  )
}

try{ Automation.displayName ||= 'Automation' } catch {}